import { useEffect, useState } from 'react';

/**
 * This hook handles encapsulating the logic related to generating Object URLs
 * in the application given a Blob.
 *
 * This will also handle when the component unmounts making sure the gerneated
 * blbob has been removed to prevent continual memory consumption.
 *
 * @param initialBlob Value to utilize for the initial Object URL.
 *
 * @return url Current string representation of the URL Object
 * @return setBlob Function to handle updating the URL Object blob
 * information.
 */
export const useObjectUrl = (initialBlob: Blob = null) => {
  const [blob, setBlob] = useState(initialBlob);
  const [url, setUrl] = useState('');

  useEffect(() => {
    if (blob) {
      setUrl(URL.createObjectURL(blob));
    }

    return () => {
      URL.revokeObjectURL(url);
      setUrl(null);
    };
  }, [blob]);

  return [url, setBlob] as const;
};
